import { Accordion } from "@/components/ui/accordion";
import Aircraft from "./aircraft-filter";
import AirlineFilter from "./airline-filter";
import FlightNumberFilter from "./flight-number-filter";
import FlightSchedules from "./flight-schedules";
import FlightSortTabs from "./flight-sort-tabs";
import LayoverCity from "./layover-city";
import PriceRange from "./price-range";
import Refutability from "./refutability-filter";
import Stoppage from "./stoppage-filter";

export function FilterSection() {
  return (
    <Accordion
      className="space-y-2 py-2"
      type="multiple"
      defaultValue={
        [
          "price",
          "flight-numbers",
          "flight_schedules",

          // "airlines",
          // "aircraft",
          // "layover_city",
          // "stoppage",
          // "refund",
        ].filter(Boolean) as string[]
      }
    >
      <FlightSortTabs />
      <FlightNumberFilter />
      <PriceRange />

      <FlightSchedules />
      <AirlineFilter />
      <Aircraft />
      <LayoverCity />
      <Stoppage />
      <Refutability />
    </Accordion>
  );
}
